<template>
  <div data-testid="sign-up-form-skeleton" role="status" aria-live="polite">
    <span class="sr-only">Loading your benefit signup form…</span>
    <Skeleton custom-class="h-28 w-4/5 mb-8" />
    <Skeleton custom-class="h-16 w-full mb-8" />
    <Skeleton custom-class="h-16 w-5/6 mb-32" />
    <Skeleton v-for="i in 5" :key="i" custom-class="h-48 w-full mt-16" />
    <Skeleton custom-class="h-24 w-full mt-24 mb-24" />
    <Skeleton custom-class="h-48 w-full" />
  </div>
</template>

<script lang="ts">
import Skeleton from '@/components/skeleton/Skeleton.vue';

export default {
  name: 'SignUpFormSkeleton',
  components: { Skeleton },
};
</script>
